
<vue-multiselect
    v-bind="$attrs"
    v-on="$listeners"
    @open="expanded = true"
    @close="expanded = false"
>
    <span
        slot="caret"
        slot-scope="{ toggle }"
        @mousedown.prevent.stop="toggle"
        class="multiselect-caret"
    >
        <AnimatedCaret :expanded="expanded" />
    </span>
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    <template
        v-for="(_, name) in $scopedSlots"
        :slot="name"
        slot-scope="slotData"
        ><slot :name="name" v-bind="slotData"
    /></template>
</vue-multiselect>
